export default{
  promotion: (state) => state.promotion,
  promotionHelpers: (state) => state.promotionHelpers
}



// WEBPACK FOOTER //
// ./src/components/promotion/store/getters.js